/**
 * DeliveryNotes API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createCustomDeliveryNote,
  createDeliveryNote,
  getDeliveryNoteById,
  getDeliveryNotes,
  getDeliveryNoteVersion,
  getDeliveryNoteVersions,
  getShareableDeliveryNote,
  getShareableDeliveryNoteHtml,
  getShareableDeliveryNotePdf,
  renderDeliveryNotePreview,
  updateDeliveryNote,
  voidDeliveryNote,
} from "../generated/delivery-notes/delivery-notes";

import { wrapListMethod, wrapMethod } from "./utils";

export const deliveryNotes = {
  /** @see getShareableDeliveryNote */
  getShareableDeliveryNote: wrapMethod(getShareableDeliveryNote),

  /** @see getShareableDeliveryNoteHtml */
  getShareableDeliveryNoteHtml: wrapMethod(getShareableDeliveryNoteHtml),

  /** @see getShareableDeliveryNotePdf */
  getShareableDeliveryNotePdf: wrapMethod(getShareableDeliveryNotePdf),

  /** @see createDeliveryNote */
  create: wrapMethod(createDeliveryNote),

  /** @see getDeliveryNotes */
  list: wrapListMethod(getDeliveryNotes),

  /** @see createCustomDeliveryNote */
  createCustom: wrapMethod(createCustomDeliveryNote),

  /** @see getDeliveryNoteById */
  get: wrapMethod(getDeliveryNoteById),

  /** @see updateDeliveryNote */
  update: wrapMethod(updateDeliveryNote),

  /** @see getDeliveryNoteVersions */
  getVersions: wrapMethod(getDeliveryNoteVersions),

  /** @see getDeliveryNoteVersion */
  getVersion: wrapMethod(getDeliveryNoteVersion),

  /** @see renderDeliveryNotePreview */
  renderDeliveryNotePreview: wrapMethod(renderDeliveryNotePreview),

  /** @see voidDeliveryNote */
  void: wrapMethod(voidDeliveryNote),
} as const;

export type DeliveryNotesApi = typeof deliveryNotes;
